import React      from 'react';
import utils      from '../../utils';
import values     from '../../values';
import Cookies    from 'js-cookie';
import Context    from '../../context';
import constants  from '../../values/constants';
import Components from './Components';

import { DRIVER_TABS    } from '../../values/subTabs';
import { ITopMenuItem   } from '../../types/common.interface';
import { useTranslation } from 'react-i18next';
import {
  SubTabs,
  BreadCrumb,
  Pagination,
  TableHeader,
  TableLoading,
  ResponsiveView,
} from '../../components';

import './index.sass';
import ApproveDriver from "./Components/ApproveDriver";


interface iItem {
  value: string;
  pathname: string;
  name?: string;
}

type Props = {
  resultService: any;
  role: 'ADMIN' | 'SUPER_AGENT_SCHOOL' | 'COMPANY';
};

const ServiceScreen: React.FC<Props> = (props: Props): React.ReactElement => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const { status, data } = props.resultService;
  const { setRequestService, requestService, showModal } = React.useContext(Context.ServiceScreen);

  const writePermission: string | undefined = Cookies.get(constants.USER.WRITE_PERMISSION)?.toString();
  const userType: string = utils.stringHexConversion.reverse(Cookies.get(constants.USER.TYPE));

  const { t } = useTranslation();

  const headerTable: Array<string> =
    userType === "COMPANY"
      ? requestService?.filters?.isUnknownDriver ? values.tableHeaders.SERVICE_HEADER_FOR_COMPANY_UNKNOWN_DRIVER : values.tableHeaders.SERVICE_HEADER_FOR_COMPANY
      : requestService?.filters?.isUnknownDriver ? values.tableHeaders.SERVICE_HEADER_UNKNOWN_DRIVER             : values.tableHeaders.SERVICE_HEADER

  let tabs: Array<iItem> = DRIVER_TABS.map((item) => ({ ...item, value: t(item.value) }));

  const [selectedTab, setSelectedTab] = React.useState<iItem>(tabs[0])

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // * =================================================================================================================
  // * -------------------------------------------- Start Local Functions ----------------------------------------------

  function onClickSubTab(event: iItem): void {
    if (event.value !== selectedTab.value) {
      setSelectedTab(requestService?.filters?.isUnknownDriver ? tabs[0] : tabs[1]);
      setRequestService && setRequestService(
        {...requestService, page: 1, filters: {
            ...requestService?.filters, isUnknownDriver: !requestService?.filters?.isUnknownDriver
          }
        }
      );
    }
  }

  // * --------------------------------------------- End Local Functions -----------------------------------------------
  // * =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  return (
    <ResponsiveView.Container id="service-screen-container">
      <ResponsiveView.Row className="table-options-wrapper">
        <SubTabs tabs={tabs} onClick={onClickSubTab} selected={selectedTab as ITopMenuItem} />
      </ResponsiveView.Row>
      <ResponsiveView.Row className="table-options-wrapper">
        <ResponsiveView.Column extraLarge={3} large={5} medium={5} className="bread-crumb-wrapper">
          <BreadCrumb />
        </ResponsiveView.Column>
        <ResponsiveView.Column extraLarge={4} large={5} medium={7} className="search-and-filter-wrapper">
          {writePermission === "true" && (<Components.Create role={props.role} />)}
          <Components.Filter />
          <Components.Search />
        </ResponsiveView.Column>
      </ResponsiveView.Row>
      <div className="table-content-wrapper">
        <table>
          <TableHeader headers={headerTable.map((item: string) => t(item))} />
          {status === "loading" ? (<TableLoading />) : (<Components.Body data={data?.result?.docs} />)}
        </table>
      </div>
      {status === "success" &&
        data?.result?.totalDocs >
          values.constants.PANEL_TABLE_DEFAULT_LIMIT && (
          <div className="pagination">
            <Pagination
              page={requestService?.page}
              totalPages={data?.result?.totalPages}
              onPaginate={(page: number) => setRequestService!({ ...requestService, page })}
            />
          </div>
        )}
      <Components.ShowInformation />
      <Components.Invoices />
      {writePermission === "true" && (
        <>
          <Components.Update.Student />
          <Components.Update.Service role={props.role} />
          <Components.Approve role={props.role} />
          <Components.Reject />
          <Components.PayOffline />
          <Components.ApproveDriver />
        </>
      )}
    </ResponsiveView.Container>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================

};

export default ServiceScreen;
